module.exports = __webpack_public_path__ + "img/room.999a661f.png";